<template>
  <section
    v-if="itemData"
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat backdrop-blur-sm desktop:bg-center"
    :style="contextBannerStyle"
  >
    <div class="container-wrap flex h-banner">
      <div class="flex w-full flex-col justify-center">
        <div
          class="w-full tablet:max-w-[736px] desktop:max-w-[760px]"
          :class="itemData.themeStyle === 'dark' ? 'text-white' : 'text-black'"
        >
          <h1 class="text-solution-h1 mb-6 line-clamp-1 tablet:mb-3">
            {{ itemData.title }}
          </h1>
          <p v-if="!isMobile" class="mb-6 line-clamp-3 desktop:line-clamp-2">
            {{ itemData.description }}
          </p>
        </div>
        <div class="flex flex-wrap">
          <TheButton
            v-if="button01?.text"
            :id="button01?.trackingCode"
            :to="provideFormatUrl(button01.link)"
            :title="button01.text"
            class="mb-3 w-full tablet:mb-0 tablet:mr-2.5 tablet:w-[180px] desktop:mr-6"
          >
            <span class="text-sm font-bold">
              {{ button01.text }}
            </span>
          </TheButton>
          <TheButton
            v-if="button02?.text"
            :id="button02.trackingCode"
            :to="provideFormatUrl(button02.link)"
            :title="button02.text"
            type="outline"
            class="w-full bg-white/50 tablet:w-[180px]"
          >
            <span class="text-sm font-bold">
              {{ button02.text }}
            </span>
          </TheButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  interface IButton {
    text: string;
    link: string;
    trackingCode?: string;
  }

  interface IBanner {
    title: string;
    description: string;
    buttons: IButton[];
    themeStyle: 'light' | 'dark';
  }

  interface IProps {
    itemData: IBanner;
  }

  const props = defineProps<IProps>();

  const { isMobile } = useScreen();
  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const contextBannerStyle = computed((): string => {
    const path: string = provideResponsiveImgUrl('banner');

    return props.itemData.themeStyle === 'dark'
      ? `background-image: linear-gradient(to right, #323233 0%, rgba(255, 255, 255, 0.5) 50%, rgba(50, 50, 51, 0) 100%), url(${path})`
      : `background-image: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), url(${path})`;
  });

  const button01 = computed(
    (): IButton | undefined => props.itemData.buttons[0]
  );

  const button02 = computed(
    (): IButton | undefined => props.itemData.buttons[1]
  );

  export type { IBanner, IButton };
</script>
